<template>
  <div class="modeTable">
    <h3>{{ title }}</h3>
    <el-table border style="width:100%" :data="tableData">
      <el-table-column align="center" prop="kcbh" label="课程编号">
      </el-table-column>
      <el-table-column align="center" prop="kcmc" label="课程名称">
      </el-table-column>
      <el-table-column align="center" prop="xf" width="50" label="学分">
      </el-table-column>
      <el-table-column align="center" prop="kcsxmc" width="80" label="课程属性">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    tableData: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="less" scoped>
.modeTable {
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  h3 {
    height: 40px;
    line-height: 40px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: bolder;
    padding: 0 15px;
  }
  // el-table
  /deep/.el-table {
    thead {
      th {
        padding: 8px 0;
        background-color: #f9f9f9;

        .cell {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #333333 !important;
          letter-spacing: 0;
          font-weight: bolder;
        }
      }
    }
    tbody {
      td {
        padding: 8px 0 !important;
        background-color: #fff;
        border-bottom: 1px solid #ebeef5 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xyjdck/modeTable.vue